export const SURVEY_TYPES: Record<string, SurveyType> = Object.freeze({
  STANDARD: 'standard',
  ONBOARDING: 'onboarding',
  EXIT: 'exit',
});
